/**
 * Resolve product code on a sale line item (API may nest it under product or meta).
 */
export function getSaleItemProductCode(item) {
  if (!item) return '—';
  const meta = item.meta && typeof item.meta === 'object' ? item.meta : {};
  const code =
    item.product?.product_code
    ?? item.product?.productCode
    ?? item.product_code
    ?? item.productCode
    ?? meta.product_code
    ?? meta.productCode;
  const text = code != null ? String(code).trim() : '';
  return text || '—';
}

export function formatSaleItemProductLabel(item) {
  const name = item?.product?.name ?? item?.product_name ?? item?.productName ?? '—';
  const code = getSaleItemProductCode(item);
  if (code === '—') return name;
  return `${code} — ${name}`;
}
